/**
 * Decide whether an auth-state transition abandons a previous realtime identity
 * and therefore requires tearing down the shared ActionCable consumer + clearing
 * cached identity (F2).
 *
 *   logout        (A → null) → true
 *   account switch (A → B)   → true
 *   initial login (null → A) → false  ← must NOT disconnect the consumer that
 *                                        FriendProvider is about to create
 *   no change      (A → A)   → false
 *
 * Pure so it is unit-testable without React/Firebase.
 */
export function shouldResetRealtimeIdentity(
  prevUid: string | null,
  newUid: string | null,
): boolean {
  return prevUid !== null && prevUid !== newUid;
}

/**
 * Stable key for the currently authenticated identity. Changes on EVERY account
 * change — including a direct A→B switch that leaves `isLoggedIn` true — so
 * consumers keyed on it (FriendProvider, useIdentity) re-initialize for B (F2).
 *
 *   Firebase user present → its uid
 *   dev-token path (dev only) → `dev:<token>`
 *   logged out → null
 */
export function computeIdentityKey(
  uid: string | null | undefined,
  devToken: string | null | undefined,
  isDev: boolean,
): string | null {
  if (uid) return uid;
  if (isDev && devToken) return `dev:${devToken}`;
  return null;
}
